export default __webpack_public_path__ + "static/1338-fbe815df4fa1effa113a6a4636a74abb.gif";